module.exports = __webpack_public_path__ + "img/icb-co-novice-e@2x.bd6575f7.png";